import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { MfaService, MfaChallengeRequest } from '@src/app/shared/backend/mfa';
import { firstValueFrom } from 'rxjs';
import { SessionService } from '@src/app/shared/services/session.service';
import { LoginNavigationService } from '@src/app/shared/services/loginNavigation.service';

@Component({
    selector: 'app-otp-verified',
    templateUrl: './otp-verified.component.html',
    styleUrls: ['./otp-verified.component.scss'],
    host: {
        class: 'app-otp-verified'
    },
    standalone: false
})
export class OtpVerifiedComponent implements OnInit {

  verificationCode: string = '';
  hasError: boolean = false;
  errorMessage: any;
  timeout: boolean = false;

  constructor(
    public translate: TranslateService,
    public router: Router,
    private mfaService: MfaService,
    private session: SessionService,
    private loginNavigationService: LoginNavigationService) { }

  ngOnInit() {
    setTimeout(() => {
      this.timeout = true;
    }, 150 * 1000);
  }

  submitOnPressEnter(event: any) {
    if (event.keyCode === 13) {
      this.verify();
    }
  }

  async verify() {
    const session = sessionStorage.getItem('mfaSession');
    const username = sessionStorage.getItem('mfaUsername');

    if (!username || !session || !this.verificationCode) {
      console.error('Missing MFA data');
      this.hasError = true;
      return;
    }

    const payload: MfaChallengeRequest = {
      username,
      session,
      userCode: this.verificationCode
    };

    try {
      console.log(payload);
      const mfaResponse = await firstValueFrom(this.mfaService.apiMfaChallengePost(payload));

      const { accessToken, refreshToken, apiToken } = mfaResponse?.authenticationResult ?? {};

      if (!accessToken || !refreshToken || !apiToken) {
        throw new Error('MFA challenge did not return tokens');
      }

      this.session.applyTokens({
        accessToken,
        refreshToken,
        apiToken
      });
      this.session.hasAccess = true;

      await this.session.getUser();

      this.hasError = false;

      const landingPage = await this.loginNavigationService.resolveLandingPage();
      await this.loginNavigationService.navigateLandingPage(landingPage);
    } catch (error: any) {
      if (this.timeout) {
        this.errorMessage = 'MODALBOXES.MFA_TIMEOUT';
      } else {
        this.errorMessage = 'MODALBOXES.MFA_WRONG_VERIFICATION_CODE';
      }
      console.error('MFA verification failed:', error, this.errorMessage, this.timeout);
    }
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }
}
